<template>
  <div>
    <cash-position-component></cash-position-component>
  </div>
</template>

<script>
import CashPositionComponent from "@/components/CashPositionComponent";

export default {
  components: {
    CashPositionComponent,
  },
};
</script>

<style lang="scss" scoped></style>
